import * as React from "react";
import {
  container,
  title,
  description,
  row,
  ctaContainer,
  stickyContainer,
  customSticky,
  title1,
  messageWrapper,
  pageBannerWrapper,
  styledContainer,
} from "./PageBanner.module.scss";
import { Row, Col, Container, Nav } from "react-bootstrap";
import Sticky from "react-sticky-el";
import { useAppSelector } from "../../../hooks";
import { searchSelector } from "../../../redux/slices/Search/search";
import { useScrollVisibility } from "../../../context/scrollVisibilityContext";
import { useWebFramed } from "../../../hooks/useWebFramed";
import { useMobileDetectContext } from "../../../context/MobileDetectContext";

export const StyledContainer: React.FC<any> = (props) => {
  return (
    <div className={`${container} ${styledContainer}`}>{props.children}</div>
  );
};
export const Title: React.FC<any> = (props) => {
  if (props.isPrimaryPage) {
    return (
      <h1 className={`${title} ${title1}`} id={props.titleId}>
        {props.title}
      </h1>
    );
  } else {
    return (
      <div className={title} id={props.titleId}>
        {props.title}
      </div>
    );
  }
};
export const SecondryTitle: React.FC<{
  titleId: string;
  secondaryTitle: string;
}> = (props) => {
  return (
    <div className={title} id={props.titleId}>
      {props.secondaryTitle}
    </div>
  );
};
export const PageBannerWrapper: React.FC<any> = (props) => {
  return (
    <Container
      className={`${container} p-0 position-relative ${pageBannerWrapper}`}
    >
      {props.children}
    </Container>
  );
};
export const Description: React.FC<any> = (props) => {
  return (
    <div
      id={props.decsId}
      className={description}
      dangerouslySetInnerHTML={{
        __html: props.description ? props.description : "",
      }}
    ></div>
  );
};
export const StyledRow: React.FC<any> = (props) => {
  return (
    <Container className={messageWrapper} fluid="sm">
      <Row className={row}>{props.children}</Row>
    </Container>
  );
};
export const CtaContainer: React.FC<any> = (props) => {
  const { isMobileOnly } = useMobileDetectContext();
  return (
    <div
      className={ctaContainer}
      style={!isMobileOnly ? { minHeight: props.minHeight } : {}}
    >
      {props.children}
    </div>
  );
};
export const MenuBar: React.FC<any> = (props) => {
  return (
    <Container
      {...props}
      style={
        props.brand && props.brand.length
          ? {
              backgroundColor:
                props.brand[0].field_brandbars_bg_color?.color || "#404040",
              color:
                props.brand[0].field_brandbars_fore_color?.color || "#FFFFFF",
            }
          : { backgroundColor: "#404040", color: "#FFFFFF" }
      }
    >
      {props.children}
    </Container>
  );
};
export const StickyContainer: React.FC<{ children: any }> = (props) => {
  const { isVisible } = useScrollVisibility();
  const isWebFramed = useWebFramed();
  const search = useAppSelector(searchSelector);
  const searchVal = !!(search.searchString.length > 0);
  const getTopPosition = () => {
    if (isVisible) {
      if (!searchVal) return "60px";
      if (isWebFramed) return "68px";
      return "73px";
    } else {
      return "0px";
    }
  };
  return (
    <Sticky
      className={stickyContainer}
      stickyClassName={customSticky}
      stickyStyle={{ top: getTopPosition(), zIndex: "100" }}
      positionRecheckInterval={3}
    >
      {props.children}
    </Sticky>
  );
};

export const MenuBarContent: React.FC<any> = (props) => {
  const [hoveredAnchor, setHoveredAnchor] = React.useState<string | null>(null);
  const [activeTab, setActiveTab] = React.useState<string | null>(null);

  const handleClickTab = (_id: string) => {
    const targetElm = document.getElementById(_id);
    if (targetElm) {
      targetElm.scrollIntoView();
    }
    setActiveTab(_id);
  };

  const handleAnchorHover = (anchor: string | null) => {
    setHoveredAnchor(anchor);
  };

  return (
    <MenuBar fluid className="pt-2 pb-2 d-lg-block menuBar" brand={props.brand}>
      <Container fluid="sm">
        <Row>
          <Col>
            <Nav as="ul" className="menu justify-content-center">
              {props.menu.map((item: any) => {
                const isHovered = hoveredAnchor === item.id;
                const isActive = activeTab === `paragraph-${item.id}`;

                return (
                  <Nav.Item
                    as="li"
                    key={item.id}
                    onClick={() => handleClickTab(`paragraph-${item.id}`)}
                  >
                    <Nav.Link
                      style={{
                        color: props.brand[0].field_brandbars_fore_color?.color,
                        textDecoration:
                          isActive || isHovered
                            ? `underline ${props.brand[0].field_brandbars_fore_color?.color}`
                            : undefined,
                        textUnderlinePosition:
                          isActive || isHovered ? "under" : undefined,
                        textDecorationThickness:
                          isActive || isHovered ? "3px" : undefined,
                      }}
                      onMouseEnter={() => handleAnchorHover(item.id)}
                      onMouseLeave={() => handleAnchorHover(null)}
                    >
                      {item.link}
                    </Nav.Link>
                  </Nav.Item>
                );
              })}
            </Nav>
          </Col>
        </Row>
      </Container>
    </MenuBar>
  );
};
export const isUrlExternal = (url: string): boolean => {
  if (url.toLowerCase().startsWith("http")) {
    const urlHost = new URL(url).hostname;
    if (typeof window !== "undefined")
      return urlHost !== window.location.hostname;
    return true;
  } else {
    return false;
  }
};
